export type OrderHistoryPoLookupRow = {
  transaction_id: string;
  order_meta_id: string;
};

export function resolveOrderMetaIdByPo(
  poNumber: string,
  orders: OrderHistoryPoLookupRow[] | undefined
): string | null {
  if (!poNumber || !orders?.length) {
    return null;
  }

  const match = orders.find((order) => order.transaction_id === poNumber);
  return match?.order_meta_id ?? null;
}

export function buildOrderDetailHref(
  orderMetaId: string,
  warehouseId: string
): string {
  return `/order-detail/${orderMetaId}?warehouse=${warehouseId}`;
}
